// The official site and its API are deployed together. Never send production
// customer/session data to a preview backend baked into an earlier build.
export function resolveApiBase(configuredOrigin = '', location = undefined) {
  const current = location === undefined && typeof window !== 'undefined' ? window.location : location;
  if (current?.protocol === 'https:' &&
      ['xavierassembly.com', 'www.xavierassembly.com'].includes(current.hostname) &&
      (!current.port || current.port === '443')) return '/api';
  return `${configuredOrigin || ''}/api`;
}

export const API_BASE = resolveApiBase(process.env.REACT_APP_BACKEND_URL || '');
